module.exports = __webpack_public_path__ + "img/Liability_Selected.ceee6fce.svg";